import { format } from 'date-fns';
import { LuClock } from 'react-icons/lu';
import { FiCheckCircle } from 'react-icons/fi';

const statusLabels = {
  InProgress: 'In Progress',
  New: 'New',
  Acknowledged: 'Acknowledged',
  Waiting: 'Waiting',
  Resolved: 'Resolved',
  Closed: 'Closed'
};

const statusColors = {
  New: 'bg-purple-500',
  Acknowledged: 'bg-blue-500',
  InProgress: 'bg-yellow-500',
  Waiting: 'bg-gray-500',
  Resolved: 'bg-green-500',
  Closed: 'bg-gray-400'
};

export default function StatusTimeline({ history }) {
  const statusHistory = history ? JSON.parse(history) : [];

  if (statusHistory.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-semibold text-gray-900 mb-4">Status Timeline</h3>
      <div className="space-y-4">
        {statusHistory.map((item, index) =>
        <div key={index} className="flex gap-4">
            {/* Timeline Line */}
            <div className="flex flex-col items-center">
              <div className={`w-3 h-3 rounded-full ${statusColors[item.status]} ring-4 ring-white shadow`} />
              {index < statusHistory.length - 1 &&
            <div className="w-0.5 h-full bg-gray-200 mt-1" />
            }
            </div>
            {/* Content */}
            <div className="flex-1 pb-4">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-medium text-gray-900">
                  {statusLabels[item.status] || item.status}
                </span>
                {index === statusHistory.length - 1 &&
              <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">
                    Current
                  </span>
              }
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <LuClock className="w-3 h-3" />
                {format(new Date(item.timestamp), 'MMM d, yyyy h:mm a')}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>);

}